import { Image } from "@elements/ResponsiveImage/Image";
import { twMerge } from "tailwind-merge";
export type VideoPosterProps = {
  formattedTime?: string | undefined;
  src: string;
  nowPlaying: boolean;
};

export default function VideoPoster({
  formattedTime,
  src,
  nowPlaying,
}: VideoPosterProps) {
  return (
    <div className="w-[140px] h-[95px]">
      <div className={`bg-black-100 relative`}>
        {!nowPlaying && (
          <span
            className="text-white-100 bg-black-100 text-xs bg-opacity-60 absolute z-1 right-[3px] bottom-[3px] py-[2px] px-xxs"
            data-testid="time"
          >
            {formattedTime}
          </span>
        )}
        <Image
          objectFit="contain"
          src={src}
          className={twMerge("w-[140px] h-[95px] ", nowPlaying && "blur-sm")}
          srcWidth={259}
          srcHeight={130}
          alt="brightcove video"
          dataTestId="image"
        />
        {nowPlaying && (
          <div className="bg-black-300 bg-opacity-[50%] z-3 top-0 absolute h-full w-full text-white"></div>
        )}
        {nowPlaying && (
          <div className="z-3 absolute text-[white] text-[16px] h-fit top-0 r-0 m-[auto] bottom-0 left-0 right-0">
            Now playing
          </div>
        )}
      </div>
    </div>
  );
}
